

export const MagstimThemes = {
    "Desktop": {
        "MagstimHeaderBarHeight":"70px",
        "MagstimNavBarIconSize":"30px",
        "MagstimNavBarFontSize":"18px",
        "MagstimNavBarFontSizeSmall":"18px",
        "ControlSize":"lg",
        "labelFontSize":"22.4px"
    },
    "Web":{
        "MagstimHeaderBarHeight":"60px",
        "MagstimNavBarIconSize":"22px",
        "MagstimNavBarFontSize":"16px",
        "MagstimNavBarFontSizeSmall":"14px",
        "ControlSize":"",
        "labelFontSize":"18px"
    }
}

export function CurrentTheme() {

    let currentTheme;
    // eslint-disable-next-line no-undef
    switch(localStorage.getItem('Configuration')) {
        case 'Desktop':
            currentTheme = MagstimThemes.Desktop;
          break;
        case 'Web':
            currentTheme = MagstimThemes.Web;
          break;
        default:
            currentTheme = MagstimThemes.Desktop;
      }

    return currentTheme
}